import { createReducer } from '../../utilities';
import {
    REQUEST_FETCH_STATS_NEW_ACTIVE_USERS,
    SUCCESS_FETCH_STATS_NEW_ACTIVE_USERS,
    FAIL_FETCH_STATS_NEW_ACTIVE_USERS,
} from "../../../actions/entities/statistics/activeUsers";

const initialState = {
    data: null,
    error: false,
    isFetching: false,
};

function requestFetch(state) {
    return {
        ...state,
        isFetching: true,
    };
}

function successFetch(state, action) {
    const { data } = action;
    return {
        ...state,
        data,
        isFetching: false,
    };
}

function failFetch(state, action) {
    const { error } = action;
    return {
        ...state,
        isFetching: false,
        error
    };
}

export default createReducer(initialState, {
    [REQUEST_FETCH_STATS_NEW_ACTIVE_USERS]: requestFetch,
    [SUCCESS_FETCH_STATS_NEW_ACTIVE_USERS]: successFetch,
    [FAIL_FETCH_STATS_NEW_ACTIVE_USERS]: failFetch,
});



// WEBPACK FOOTER //
// ./src/reducers/app/statistics/newActiveUsers.js